import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createShopReadyCommentByAdmin($type: String!) {
    createShopReadyCommentByAdmin(input: { type: $type }) {
      _id
      type
    }
  }
`;

const GET = gql`
  query getShopReadyCommentsByAdmin($limit: Int, $skip: Int) {
    getShopReadyCommentsByAdmin(pagination: { limit: $limit, skip: $skip }) {
      _id
      type
    }
  }
`;

const COUNT = gql`
  query getShopReadyCommentsByAdminCount {
    getShopReadyCommentsByAdminCount
  }
`;

const UPDATE = gql`
  mutation updateShopReadyCommentByAdmin($id: ID!, $type: String!) {
    updateShopReadyCommentByAdmin(id: $id, input: { type: $type }) {
      _id
      type
    }
  }
`;

const DELETE = gql`
  mutation removeShopReadyCommentByAdmin($idSet: [ID!]!) {
    removeShopReadyCommentByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const FIELDS = [
  {
    name: "type",
    label: "Comment",
    type: "text",
    required: true,
    hint: "Keep it short — it appears as a tappable chip in the app.",
  },
];

/**
 * ShopReadyComments - the canned remarks a customer taps to
 * describe a shop after an order.
 */
const ShopReadyComments = () => (
  <SettingsList
    title="Shop ready comments"
    description="What a customer can tap to describe a shop after an order."
    singular="comment"
    list={{ query: GET, key: "getShopReadyCommentsByAdmin" }}
    count={{ query: COUNT, key: "getShopReadyCommentsByAdminCount" }}
    create={{ mutation: ADD, variables: (values) => ({ type: values.type.trim() }) }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({ id: row._id, type: values.type.trim() }),
    }}
    remove={{ mutation: DELETE }}
    columns={[{ key: "type", label: "Comment", width: "3fr" }]}
    fields={FIELDS}
    toValues={(row) => ({ type: row.type })}
  />
);

export default ShopReadyComments;
